module.exports = __webpack_public_path__ + "img/box1_icon3.33311f3b.png";